import { StudioVisualizationType } from '@blockworks/platform/api/research/studio/visualizations';

import { type GetVisualizationPropsArgs } from '../models';

import { counterWorkflow } from './counter';
import { pieWorkflow } from './pie';
import { sankeyWorkflow } from './sankey';
import { tableWorkflow } from './table';
import { timeseriesWorkflow } from './timeseries';
import { initialTransforms } from './utils';

const getVisualizationProps = async (args: GetVisualizationPropsArgs) => {
    switch (args.type) {
        case StudioVisualizationType.Timeseries: {
            return timeseriesWorkflow(args);
        }
        case StudioVisualizationType.Table: {
            return tableWorkflow(args);
        }
        case StudioVisualizationType.Counter: {
            return counterWorkflow(args);
        }
        case StudioVisualizationType.Pie: {
            return pieWorkflow(args);
        }
        case StudioVisualizationType.Sankey: {
            return sankeyWorkflow(args);
        }
        default: {
            return initialTransforms(args);
        }
    }
};

export { getVisualizationProps };
